import { render, staticRenderFns } from "./TheSignatureDocLink.vue?vue&type=template&id=3f69a83f&scoped=true&"
import script from "./TheSignatureDocLink.vue?vue&type=script&lang=js&"
export * from "./TheSignatureDocLink.vue?vue&type=script&lang=js&"
import style0 from "./TheSignatureDocLink.vue?vue&type=style&index=0&id=3f69a83f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f69a83f",
  null
  
)

export default component.exports